import { render, staticRenderFns } from "./vme-supplier-temp.html?vue&type=template&id=83474ec4&scoped=true&external"
import script from "./vme-supplier-temp.ts?vue&type=script&lang=ts&external"
export * from "./vme-supplier-temp.ts?vue&type=script&lang=ts&external"
import style0 from "./vme-supplier-temp.scss?vue&type=style&index=0&id=83474ec4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83474ec4",
  null
  
)

/* custom blocks */
import block0 from "./vme-supplier-temp.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fhome%2Fvme-supplier-temp%2Fvme-supplier-temp.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VListItemContent,VListItemTitle,VRow})
